import { IAuthContextState } from "../context/authContext/AuthContext";
import { BusinessHubspotRole } from "../enums/business-role.enum";
import { AppRoles, CustomManagementRole } from "../enums/role.enum";
import { IUser } from "../interfaces/user.interface";
import { SubscriptionTierEnum } from "../enums/SubscriptionTier";

export const capitalizeWord = (str: string | undefined) => {
    if (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    return str;
};

export const isB2cParentOrStudent = (state: IAuthContextState) => {
    return (
        state?.user?.group_role === CustomManagementRole.B2C_STUDENT ||
        (state?.user?.role === AppRoles.PARENT && !state?.user?.organization)
    );
};

export const getFormattedSubscriptionType = (
    subscriptionType: string
): string => {
    switch (subscriptionType) {
        case SubscriptionTierEnum.QUARTERLY:
            return "QUARTERLY";
        case SubscriptionTierEnum.MONTHLY:
            return "MONTHLY";
        case SubscriptionTierEnum.YEARLY:
        case SubscriptionTierEnum.CLINICIAN_SUBSCRIPTION_ANNUAL:
            return "YEARLY";
        default:
            return subscriptionType.toUpperCase();
    }
};

export const isYearlySubscription = (subscriptionType: string): boolean => {
    return subscriptionType.toLowerCase() === "yearly";
};

export const resolveGroupRole = (user?: IUser) => {
    if (!user) return null;

    switch (user.role) {
        case AppRoles.CLINICIAN:
            if (user.persona === BusinessHubspotRole.B2C_CLINICIAN) {
                return CustomManagementRole.B2C_CLINICIAN;
            }
            if (user.organization) {
                return user.id === user.organization.owner?.id
                    ? CustomManagementRole.B2B_ACCOUNT_OWNER
                    : CustomManagementRole.B2B_CLINICIAN;
            }
            return CustomManagementRole.B2C_CLINICIAN;

        case AppRoles.PARENT:
            if (user.organization) {
                return user.parentInfo?.subRole === AppRoles.TEACHER
                    ? CustomManagementRole.B2B_TEACHER
                    : CustomManagementRole.B2B_PARENT;
            }
            return user.parentInfo?.subRole === AppRoles.TEACHER
                ? CustomManagementRole.B2C_STUDENT
                : CustomManagementRole.B2C_STUDENT;

        case AppRoles.ADMIN:
            return AppRoles.ADMIN;

        default:
            return null;
    }
};
